/**
 * PR 9.2n 方案A:Agent 摘要可读性 helper。
 *
 * 后端已把 text 做成纯中文 prose + 结构化 citations(legacy 行也由后端剥 tag)。
 * 前端这里做**防御性**剥 tag(可见 prose 0 raw token)+ citation chip 渲染。
 */

const INLINE_TAG_RE = /\[(brand|model|source|metric):([^\]]+)\]/g;

/** 一条数据依据(citation),label 由后端解析。 */
export interface Citation {
  type: 'brand' | 'model' | 'source' | 'metric';
  id: string;
  label: string;
  metric?: string;
  value?: number | string;
}

/** citations_by_section:key = "executive_summary" | 6 段名 | "legacy"。 */
export type CitationsBySection = Record<string, Citation[]>;

/** 防御性剥内联 [type:id] tag → 仅留 id 文本(可见 prose 0 raw bracket token)。 */
export function stripInlineTags(text: string | null | undefined): string {
  return (text ?? '').replace(INLINE_TAG_RE, '$2');
}

/** prose 是否仍含 raw tag(守卫用)。 */
export function hasRawTag(text: string | null | undefined): boolean {
  INLINE_TAG_RE.lastIndex = 0;
  return INLINE_TAG_RE.test(text ?? '');
}

/** parseStreeSections 的 heading → citations_by_section key 映射。 */
export function sectionCitationKey(heading: string): string {
  return heading.includes('执行摘要') ? 'executive_summary' : heading.trim();
}

/** citation → chip 显示文案(label + value)。 */
export function citationChipLabel(c: Citation): string {
  if (c.value !== undefined && c.value !== null && c.value !== '') {
    return `${c.label}：${c.value}`;
  }
  return c.label;
}
